// extracted by mini-css-extract-plugin
module.exports = {"editor":"HtmlEditor_editor__2CPth"};